/* Rich text – "Read more" for the text block (rich-text section).
   Collapses the text to --read-more-height and toggles it with a button.
   The full text stays in the DOM (SEO friendly). */
if (!customElements.get('rich-text-read-more')) {
  class RichTextReadMore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.rich-text-read-more__content');
      this.actions = this.querySelector('.rich-text-read-more__actions');
      this.button = this.querySelector('.rich-text-read-more__btn');
      this.label = this.button?.querySelector('span');
      if (!this.content || !this.button) return;

      this.expanded = false;
      this.onClick = this.toggle.bind(this);
      this.button.addEventListener('click', this.onClick);

      this.check = this.check.bind(this);
      this.resizeObserver = new ResizeObserver(this.check);
      this.resizeObserver.observe(this.content);
      if (document.fonts) document.fonts.ready.then(this.check);
      this.check();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.resizeObserver?.disconnect();
    }

    collapsedHeight() {
      return parseFloat(getComputedStyle(this).getPropertyValue('--read-more-height')) || 160;
    }

    // Show the button only when the text is taller than the collapsed height
    check() {
      if (this.expanded) return;
      const isLong = this.content.scrollHeight > this.collapsedHeight() + 2;
      this.content.classList.toggle('is-collapsed', isLong);
      this.actions.hidden = !isLong;
    }

    toggle() {
      const content = this.content;
      if (this.expanded) {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.offsetHeight; // force reflow so the collapse animates
        requestAnimationFrame(() => {
          content.style.maxHeight = '';
          content.classList.add('is-collapsed');
        });
        this.expanded = false;
        this.setLabel(this.button.dataset.viewMore);
        this.scrollIntoViewIfNeeded();
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.remove('is-collapsed');
        content.addEventListener('transitionend', () => {
          if (this.expanded) content.style.maxHeight = 'none';
        }, { once: true });
        this.expanded = true;
        this.setLabel(this.button.dataset.viewLess);
      }
      content.dataset.expanded = String(this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
    }

    setLabel(text) {
      (this.label || this.button).textContent = text;
    }

    // After collapsing, keep the start of the text in view
    scrollIntoViewIfNeeded() {
      const top = this.getBoundingClientRect().top;
      if (top < 0) window.scrollBy({ top: top - 100, behavior: 'smooth' });
    }
  }
  customElements.define('rich-text-read-more', RichTextReadMore);
}
